var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"category-list-card"},[_c('div',{staticClass:"qrw-heading-xs bold qrw-content-base-primary"},[_vm._v(" "+_vm._s(_vm.category.name)+" ")]),_vm._l((_vm.category.products),function(product){return _c('ServiceGridCard',{key:product._id,attrs:{"product":product,"extended":""}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }